import sha1 from 'js-sha1'
import { PublicKey, PrivateKey } from './const';

export function getSignatureParams(params) {
    const data = {
        ...checkArrayParams(params), // 参数值为数组需要转化传参方式
        PublicKey
    };
    // 参数名升序排列
    const sortKey = Object.keys(data).sort((a, b) => a.localeCompare(b))
    let requestString = "";
    sortKey.forEach(item => {
        requestString = requestString + item + data[item];
    })
    const Signature = sha1((requestString + PrivateKey));
    const signatureParams = {
        ...data,
        Signature
    }
    return signatureParams
}

// 数组转化
function checkArrayParams(params) {
    const data = { ...params };
    if (!params) {
        return {}
    }
    Object.keys(params).forEach((key) => {
        if (Array.prototype.isPrototypeOf(params[key])) {
            params[key].forEach((item, index) => {
                data[`${key}.${index}`] = item;
            })
            delete data[key]
        }
    })
    return data
}